import ExportIcon from "@material-ui/icons/TableChart";
import React from "react";
import T from "prop-types";
import { Button } from "react-admin";

import { ProgressIcon } from "../../ProgressIcon";

export const ExportTriggerButton = ({ label, isLoading, disabled = false, onClick }) => (
	<Button
		label={label}
		alignIcon="left"
		disabled={isLoading || disabled}
		onClick={onClick}
		startIcon={isLoading ? <ProgressIcon /> : <ExportIcon />}
	/>
);

ExportTriggerButton.propTypes = {
	label: T.string.isRequired,
	isLoading: T.bool.isRequired,
	disabled: T.bool,
	onClick: T.func.isRequired,
};
